var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14255_25483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 15.5V23.125M23 28.125V28.1438",
    stroke: "#FF4A55",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87255 35.625H36.1225C36.7344 35.6207 37.3359 35.4668 37.8745 35.1766C38.4132 34.8865 38.8727 34.4689 39.2129 33.9604C39.5532 33.4519 39.7638 32.8679 39.8265 32.2592C39.8892 31.6506 39.802 31.0359 39.5725 30.4687L26.26 7.49997C25.9358 6.91384 25.4604 6.42528 24.8833 6.08507C24.3063 5.74486 23.6487 5.56543 22.9788 5.56543C22.3089 5.56543 21.6513 5.74486 21.0743 6.08507C20.4972 6.42528 20.0218 6.91384 19.6975 7.49997L6.38505 30.4687C6.15994 31.0229 6.07067 31.6229 6.12471 32.2187C6.17874 32.8144 6.3745 33.3886 6.69565 33.8932C7.01679 34.3979 7.45401 34.8184 7.97079 35.1197C8.48757 35.4209 9.06891 35.5942 9.6663 35.625",
    stroke: "#FF4A55",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14255_25483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.9d7122be.svg";
export { ForwardRef as ReactComponent };